module.exports = __webpack_public_path__ + "static/media/spanish-articles-table.9532ae9f.PNG";